import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
// import './assets/main.css';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { EmailListProvider } from "./context/EmailListContext";
import { AnalyticsDataProvider } from "./context/AnalyticsDataContext";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <EmailListProvider>
        <AnalyticsDataProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </AnalyticsDataProvider>
      </EmailListProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
